import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PostCrpUseCase } from '../../../../core/domain/car-rental-policy/usecases/postCrp.usecase';
import { crpInternational } from '@/core/domain/car-rental-policy/models/crp-body';

interface Policy {
    id: number;
    text: string;
}

interface InfoPolicy {
    id: number;
    info: string;
}

interface PoliciesResponse {
    policies: Policy[];
    info_policies: InfoPolicy[];
}

@Component({
    selector: 'fe-car-rental-policy',
    templateUrl: './car-rental-policy.component.html',
    styleUrls: ['./car-rental-policy.component.scss'],
})
export class CarRentalPolicyComponent implements OnInit, OnChanges {
    policies: Policy[] = [];
    infoPolicies: InfoPolicy[] = [];
    selectedPolicyId: number | null = null;
    placeholderItems: number[] = Array(8);
    isInternational = false;

    @Input() crpInternational?: crpInternational;

    constructor(
        private http: HttpClient,
        private router: Router,
        private postCrpUseCase: PostCrpUseCase,
    ) {}

    ngOnInit(): void {
        const currentUrl = this.router.url;
        const language = this.extractLanguageFromUrl(currentUrl);

        const jsonUrl = `${environment.cdn}/crp-json/car_rental_policy_${language}.json`;

        this.http.get<PoliciesResponse>(jsonUrl).subscribe((data) => {
            this.policies = data.policies;
            this.infoPolicies = data.info_policies;
        });
    }

    ngOnChanges(): void {
        if (this.crpInternational) {
            this.postCrpUseCase
                .execute(this.crpInternational)
                .subscribe((crp) => {
                    if (crp && crp.data) {
                        this.policies =
                            crp.data.policies?.map((policy) => ({
                                id: policy.id,
                                text: policy.text,
                            })) || [];

                        this.infoPolicies =
                            crp.data.info_policies?.map((infoPolicy) => ({
                                id: infoPolicy.id,
                                info: infoPolicy.info,
                            })) || [];
                    } else {
                        return;
                    }
                });
        }
    }

    private extractLanguageFromUrl(url: string): string {
        const segments = url.split('/');
        return segments[1] || 'en';
    }

    toggleInfo(policyId: number): void {
        this.selectedPolicyId =
            this.selectedPolicyId === policyId ? null : policyId;
    }

    getPolicyInfo(policyId: number): string {
        const policyInfo = this.infoPolicies.find(
            (info) => info.id === policyId,
        );
        return policyInfo ? policyInfo.info : '';
    }
}
